
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 31 30","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.702 -.28)"}},[_c('path',{attrs:{"id":"Stroke-157","d":"M14.7.7C6.6.7 0 7.2 0 15.3S6.6 30 14.7 30s14.7-6.6 14.7-14.7C29.3 7.2 22.8.7 14.7.7z","fill":"#fff","stroke":"#515358","stroke-miterlimit":"10"}})]),_c('path',{attrs:{"id":"Fill-1_1_","d":"M7.4 8.9c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6s-.8 1.6-1.6 1.6c-.9 0-1.6-.8-1.6-1.6m2.1 15.5v-13c.3-.1.6-.2.8-.3.8-.5 1.4-1.5 1.2-2.6-.1-1.2-1.1-2.1-2.3-2.2-1.6-.2-2.9 1-2.9 2.6 0 .9.5 1.8 1.3 2.2.2.1.5.3.8.3v13","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#515358"}}),_c('path',{staticClass:"st2",attrs:{"d":"M22.3 12.9v6.2h.7v-7.8c-.1.5-.7 1.3-.7 1.4v.2z"}}),_c('path',{staticClass:"st2",attrs:{"d":"M22.7 9.7h-.4v.9c0 1-1.3 1.9-2.2 2.1L9.9 13.8v1.1l10.4-1.3c.8-.2 1.5-.6 2-1.2.4-.4.6-.9.7-1.5V9.7h-.3zM22.7 6.3c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1-1.1-.5-1.1-1.1.5-1.1 1.1-1.1m0-.7c-1 0-1.9.8-1.9 1.9s.8 1.9 1.9 1.9 1.9-.8 1.9-1.9-.8-1.9-1.9-1.9z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/fieldCable.svg